import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchingReturnlist } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectKajeOptions, selectKajeRegister, selectPressEmplist, selectPressMemoNo, selectStitchReturn, selectStReturnOptions } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { PressMenu } from '../TitleList';
import { fetchKajeOptions, fetchPressEmplist, fetchPressMemoNo, fetchStitchReturnOptions } from '../../Store/PHPSlice/Press/PressingApi';
import { fetchKajeRegister } from '../../Store/PHPSlice/Kaje/KajeApi';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BASE_URL;


const PressingEntry = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        prMemo: '',
        sreMemo: '',
        kajeMemo: '',
        kreId: '0',
        sreId: '0',
        soId:'',
        orderType:'kaje',
        item: '',
        itemId: '',
        firmId:'',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        totQty: '',
        instructions: '',
        kaje_sts: '0',
        userId: '1',
    });
    const [errors, setErrors] = useState({});
    const [saleOrderList, setSaleOrderList] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [itemData, setItemData] = useState([]);
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [issueQtyValues, setIssueQtyValues] = useState(Array(itemData?.length).fill('0'));
    const actionMap = {
        master: fetchStitchingReturnlist,
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const prMemo = useSelector(selectPressMemoNo);
    const premplist = useSelector(selectPressEmplist);
    const sreMemoNo = useSelector(selectStReturnOptions);
    const kreMemoNo = useSelector(selectKajeOptions);
    const stReturndata = useSelector(selectStitchReturn);
    const kjReturndata = useSelector(selectKajeRegister);

  useEffect(() => {
    dispatch(fetchPressMemoNo());
    dispatch(fetchStitchReturnOptions());
    dispatch(fetchKajeOptions());
    dispatch(fetchPressEmplist());

    const fetchSaleOrderNo = async () => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSaleOrderNoForPress`
            );

            setSaleOrderList(response.data.data || []);
        } catch (error) {
            console.error(
                'Error fetching sale order no:',
                error
            );
        }
    };

    fetchSaleOrderNo();

    Object.keys(openDropdowns).forEach((dropdown) => {
        if (openDropdowns[dropdown]) {
            const action = actionMap[dropdown];
            if (action) {
                dispatch(action());
            }
        }
    });
}, [openDropdowns, dispatch]);


 useEffect(() => {
    console.log("Press Memo Response:", prMemo);

    if (prMemo?.data) {
        setFormData(prev => ({
            ...prev,
            prMemo: prMemo.data
        }));
    }
}, [prMemo]);


    useEffect(() => {
        if (issueQtyValues.length > 0) {
            const sum_issueqty = issueQtyValues.reduce((sum, qty) => sum + parseFloat(qty), 0);
            setFormData(prev => ({
                ...prev,
                totQty: sum_issueqty
            }))
        }
    }, [issueQtyValues]);

    useEffect(() => {
        if (stReturndata.data.length > 0) {
            const item = stReturndata.data[0];
            setFormData(prev => ({
                ...prev,
                sreId: item.ID,
                itemId: item.itemId,
                firmId:item.firmId,
                item: item.itemNm,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1cloth: item.m1cloth,
                m1clothNm: item.m1clothNm,
                m2cloth: item.m2cloth,
                m2clothNm: item.m2clothNm,
                m3cloth: item.m3cloth,
                m3clothNm: item.m3clothNm,
                soId: item.soId,
                sono: item.sono
            }))
        }
        if (stReturndata.Info.length > 0) {
            const item = stReturndata.Info;
            setItemData(item);
        }
    }, [stReturndata]);

   useEffect(() => {
    if (kjReturndata?.data?.length > 0) {
        const item = kjReturndata.data[0];

        setFormData(prev => ({
            ...prev,
            kreId: item.ID,
            itemId: item.itemId,
            firmId:item.firmId,
            item: item.itemNm,
            mcloth: item.mcloth,
            mclothNm: item.mclothNm,
            m1cloth: item.m1cloth,
            m1clothNm: item.m1clothNm,
            m2cloth: item.m2cloth,
            m2clothNm: item.m2clothNm,
            m3cloth: item.m3cloth,
            m3clothNm: item.m3clothNm,
            soId: item.soId,
            sono: item.sono
        }));
    }

    if (kjReturndata?.Info?.length > 0) {
        setItemData(kjReturndata.Info);
    } else {
        setItemData([]);
    }
}, [kjReturndata]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };
    const fetchSaleOrderData = async (id) => {
    try {
        const response = await axios.get(
            `${baseUrl}?apicall=getSaleOrderDataPressing&soId=${id}`
        );

        const result = response.data;

        if (result?.data?.length > 0) {
            const item = result.data[0];

            setFormData(prev => ({
                ...prev,
                soId: item.soId || item.ID,
                sono: item.sono,
                itemId: item.itemId,
                item: item.itemNm,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1cloth: item.m1cloth,
                m1clothNm: item.m1clothNm,
                m2cloth: item.m2cloth,
                m2clothNm: item.m2clothNm,
                m3cloth: item.m3cloth,
                m3clothNm: item.m3clothNm,
            }));
        }

        // table data
        if (result?.Info?.length > 0) {
            setItemData(result.Info);
        } else {
            setItemData([]);
        }
    } catch (error) {
        console.error(
            'Error fetching sale order details:',
            error
        );
    }
};
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
       setFormData(prev => ({
    ...prev,
    [dropdownType]: value
}));
        switch (dropdownType) {
            case 'sreId':
                if (value) {
                    dispatch(fetchStitchingReturnlist(value));
                } else {
                    setItemData([]);
                    setFormData({
                        sono: '',
                        soId: '',
                        empNm: '',
                        item: '',
                        itemId: '',
                        mcloth: '',
                        m1cloth: '',
                        m2cloth: '',
                        m3cloth: '',
                        mclothNm: '',
                        m1clothNm: '',
                        m2clothNm: '',
                        m3clothNm: '',
                    })
                }
                break;
           case 'soId':
    if (value) {
        setFormData(prev => ({
            ...prev,
            soId: value,
            orderType: 'direct', // set direct automatically
            kreId: '0' // clear kaje selection
        }));

        fetchSaleOrderData(value);
    } else {
        setItemData([]);

        setFormData(prev => ({
            ...prev,
            soId: '',
            sono: '',
            item: '',
            itemId: '',
            mcloth: '',
            m1cloth: '',
            m2cloth: '',
            m3cloth: '',
            mclothNm: '',
            m1clothNm: '',
            m2clothNm: '',
            m3clothNm: '',
            orderType: 'kaje' // reset
        }));
    }
    break;
            case 'kreId':

                if (value) {
                    dispatch(fetchKajeRegister(value));
                } else {
                    setItemData([]);
                    setFormData({
                        sono: '',
                        soId: '',
                        empNm: '',
                        item: '',
                        itemId: '',
                        mcloth: '',
                        m1cloth: '',
                        m2cloth: '',
                        m3cloth: '',
                        mclothNm: '',
                        m1clothNm: '',
                        m2clothNm: '',
                        m3clothNm: '',
                    })
                }
                break;
            default:
                break;
        }
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleQtyChange = (type, index, value) => {
    if (/^\d*$/.test(value)) {
        let updatedValues;

        switch (type) {
            case 'issue':
                const maxQty = parseInt(
                    itemData[index]?.sreqty || 0,
                    10
                );

                const enteredQty = parseInt(
                    value || 0,
                    10
                );

                if (enteredQty <= maxQty) {
                    updatedValues = [...issueQtyValues];
                    updatedValues[index] = value;
                    setIssueQtyValues(updatedValues);

                    // Update balance qty
                    const newBalQtyValues = [
                        ...balQtyValues,
                    ];

                    newBalQtyValues[index] =
                        maxQty - enteredQty;

                    setBalQtyValues(newBalQtyValues);
                } else {
                    alert(
                        `Entered value cannot be greater than ${maxQty}`
                    );
                }

                break;

            default:
                break;
        }
    }
};

    // const handleRadioChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //         ...formData,
    //         [name]: value
    //     });
    // };
const handleRadioChange = (e) => {
    const value = e.target.value;

    setFormData(prev => ({
        ...prev,
        orderType: value, // kaje or direct
        ...(value === 'kaje'
            ? {
                  soId: '',
                  sono: '',
              }
            : {
                  kreId: '0',
              })
    }));

    console.log("Order Type:", value);
};
    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'firm is required';
        if (!formData.challanNo) newErrors.challanNo = 'challanNo is required';
        if (!formData.sono) newErrors.sono = 'Sale Order No is required';
        if (!formData.category) newErrors.category = 'category is required';
        if (!formData.empNm) newErrors.empNm = 'empNm is required';
        if (!formData.totMtr) newErrors.totMtr = 'totMtr is required';
        return newErrors;
    };

    function convertIntoOneObject(formData, issueQtyValues, balQtyValues, itemData) {
        const data = {
            sreId: formData.sreId,
            kreId: formData.kreId,
            dt: formData.dt,
           orderType: formData.orderType,
           firmId:formData.firmId,

            prMemo: formData.prMemo,
            kjMemo: formData.kajeMemo,
            soId: formData.soId,
            empId: formData.empNm,
            itemId: formData.itemId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth || '0',
            m2cloth: formData.m2cloth || '0',
            m3cloth: formData.m3cloth || '0',
            totQty: formData.totQty || '0',
            sreqty: formData.kaje_sts === '0' ? itemData.map(item => item.rqty) : [],
            kjqty: formData.kaje_sts === '1' ? itemData.map(item => item.sreqty) : [],
            size: itemData.map(item => item.size),
            issqty: issueQtyValues,
            balqty: balQtyValues,
            instruction: formData.instructions,
            kaje_sts: formData.kaje_sts,
            userId: formData.userId,
        }
        return data;
    }
 const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const finalObject = convertIntoOneObject(
            formData,
            issueQtyValues,
            balQtyValues,
            itemData
        );

        console.log("Submitting Data:", finalObject);

        const response = await axios.post(
            `${baseUrl}?apicall=insertPressEntry`,
            finalObject,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        console.log("Response:", response.data);

        if (response.data.status === true) {
           alert("Press Entry Added Successfully");

            // reset form or reload page
            setTimeout(() => {
                window.location.reload();
            }, 0);
        } else {
            alert(
                response.data.message ||
                "Failed to save data"
            );
        }
    } catch (error) {
        console.error(
            "Error while saving data:",
            error
        );

        toast.error(
            error.response?.data?.message ||
            "Something went wrong"
        );
    }
};

    return (
        <>
            <TitleBar data={PressMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Press Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Press Memo', name: 'prMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                        {/* Order Type FIRST */}
<Grid item xs={12} md={6}>
    <Grid container alignItems="center" spacing={1}>
        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
            <FormLabel component="legend">
                Order Type :
            </FormLabel>
        </Grid>

        <Grid item xs>
            <FormControl component="fieldset" fullWidth>
                <RadioGroup
    row
    name="orderType"
    value={formData.orderType}
    onChange={handleRadioChange}
>
    <FormControlLabel
        value="kaje"
        control={<Radio />}
        label="Kaje RT Memo"
    />
    <FormControlLabel
        value="direct"
        control={<Radio />}
        label="Direct SO"
    />
</RadioGroup>
            </FormControl>
        </Grid>
    </Grid>
</Grid>


                             

             {formData.orderType === 'kaje' && (
        <Grid item xs={12} md={6}>
            <Grid container alignItems="center" spacing={1}>
                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                    <InputLabel id="kreId">
                        Kaje Memo No.:
                    </InputLabel>
                </Grid>

                <Grid item xs>
                    <FormControl fullWidth>
                        <Autocomplete
                            id="kreId"
                            name="kreId"
                            options={
                                Array.isArray(kreMemoNo?.data)
                                    ? kreMemoNo.data
                                    : [kreMemoNo?.data]
                            }
                            getOptionLabel={(option) =>
                                option.kjMemo || ''
                            }
                            value={
                                Array.isArray(kreMemoNo?.data)
                                    ? kreMemoNo.data.find(
                                          item =>
                                              item.ID ===
                                              formData.kreId
                                      ) || null
                                    : kreMemoNo?.data?.ID ===
                                      formData.kreId
                                    ? kreMemoNo.data
                                    : null
                            }
                            onChange={(event, newValue) =>
                                handleDropdownChange(
                                    {
                                        target: {
                                            name: 'kreId',
                                            value: newValue
                                                ? newValue.ID
                                                : '',
                                        },
                                    },
                                    'kreId'
                                )
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select an option"
                                    sx={{
                                        ...inputStyles,
                                        '& .MuiInputBase-root': {
                                            height: '35px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) =>
                                option.ID === value.ID
                            }
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
)}
{formData.orderType === 'direct' && (
        <Grid item xs={12} md={6}>
            <Grid container alignItems="center" spacing={1}>
                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                    <InputLabel id="soId">
                        Sale Order No.:
                    </InputLabel>
                </Grid>

                <Grid item xs>
                    <FormControl fullWidth>
                        <Autocomplete
    id="soId"
    name="soId"
    options={saleOrderList || []}
    getOptionLabel={(option) =>
        option?.sono || ''
    }
    value={
        saleOrderList.find(
            item => item.ID === formData.soId
        ) || null
    }
    onChange={(event, newValue) =>
        handleDropdownChange(
            {
                target: {
                    name: 'soId',
                    value: newValue
                        ? newValue.ID
                        : '',
                },
            },
            'soId'
        )
    }
    renderInput={(params) => (
        <TextField
            {...params}
            variant="outlined"
            placeholder="Select Sale Order"
            sx={{
                ...inputStyles,
                '& .MuiInputBase-root': {
                    height: '35px',
                },
            }}
        />
    )}
    isOptionEqualToValue={(option, value) =>
        option.ID === value.ID
    }
/>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
)}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="empNm">Master Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="empNm"
                                                    name="empNm"
                                                    options={premplist?.data}
                                                    getOptionLabel={(option) => option.empNm || ''}
                                                    value={premplist?.data?.find(item => item.ID === formData.empNm) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm')}
                                                    onOpen={() => handleDropdownOpen('empNm')}
                                                    onClose={() => handleDropdownClose('empNm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='item'>Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='item'
                                                >
                                                    {formData.item || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                                {errors.item && <FormHelperText style={errorStyles}>{errors.item}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.soId !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='sono'>SO No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='sono'
                                                    >
                                                        {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mclothNm'>Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Typography
                                                    id='mclothNm'
                                                >
                                                    {formData.mclothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                                {errors.mclothNm && <FormHelperText style={errorStyles}>{errors.mclothNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.m1cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-1:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m1clothNm'
                                                    >
                                                        {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m2cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m2clothNm'>Matching-2:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m2clothNm'
                                                    >
                                                        {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.m2clothNm && <FormHelperText style={errorStyles}>{errors.m2clothNm}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.m3cloth !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1clothNm'>Matching-3:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id='m3clothNm'
                                                    >
                                                        {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {itemData.length > 0 &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.size}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                               
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                                        {itemData ? itemData.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.issqty !== undefined ? val.issqty : 0}</TableCell>
                                                        )) : null}
                                                    </TableRow>
                                               
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={issueQtyValues[index] || '0'}
                                                                onChange={(e) => handleQtyChange('issue', index, e.target.value)}
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    {itemData ? itemData.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {balQtyValues[index] || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                {[
                                    { label: 'Press Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PressingEntry;
